import { useMemo } from "react";
import type { SelfServiceTaskForm } from "../../types";

/**
 * フォーム定義からコレクションを分離して管理するフック
 *
 * @param formDefinition フォーム定義
 * @returns 静的コレクションと動的コレクションIDの配列
 */
export function useFormCollections(formDefinition: SelfServiceTaskForm) {
  return useMemo(() => {
    const statics =
      formDefinition.form?.attributeCollections?.filter(
        (collection) => !collection.isDynamic,
      ) || [];

    const dynamics =
      formDefinition.form?.attributeCollections
        ?.filter((collection) => collection.isDynamic)
        .map((collection) => collection.id)
        .filter((id, index, self) => self.indexOf(id) === index) || [];

    return {
      staticCollections: statics,
      dynamicCollectionIds: dynamics,
    };
  }, [formDefinition.form?.attributeCollections]);
}
